export default "__VITE_ASSET__eabb6626__"